import { render } from "./AddDevice.vue?vue&type=template&id=4785016f&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"

import "./AddDevice.vue?vue&type=style&index=0&id=4785016f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4785016f"]])

export default __exports__